import * as React from 'react';
import {connect} from "react-redux";
import {Category} from "../../models/Category";
import {ApplicationState} from "../../store";
import {CategoryList}  from '../components/CategoryList';
import {ColumnData} from '../../models/ColumnData';
import {TabsService} from '../TabsService';
import {Tab, TabTypes} from '../Tab';
import {actionCategoryFetchAll, actionCategoryDelete, actionDeleteCategories} from '../../store/categories/actions'
import {Button} from "@material-ui/core";
import AddIcon from "@material-ui/icons/AddCircleOutlineRounded";
import {t} from "../../core/localization";

export interface CategoriesTabProps {
	categories: Category[]
	tab: Tab
}

export interface CategoriesTabState {
}

function mapStateToProps(state: ApplicationState) {
	return {
		categories: state.categories.list,
		tab: state.tabs.active
	};
}

class CategoriesTab extends React.Component<CategoriesTabProps, CategoriesTabState> {

	constructor(props: CategoriesTabProps) {
		super(props)
	}

	componentWillMount() {
	}

	componentWillReceiveProps(nextProps: CategoriesTabProps) {
	}

	componentDidMount() {
		actionCategoryFetchAll();
	}

	onOpenClick(category: Category){
		TabsService.createTab(t.Category + ' ' + category.title, TabTypes.CATEGORIES_NEW, category)
	}
	
	onCopyClick(category: Category){
		TabsService.createTab(t.Category + ' ' + category.title, TabTypes.CATEGORIES_NEW, { ...category, id: null })
	}
	
	onDeleteClick(category: Category){
		actionCategoryDelete(category);
	}

	onActionDeleteClick(categories: Category[]){
		actionDeleteCategories(categories);
	}

	render(): React.ReactNode {

		const {categories} = this.props;
		
		const columns = [
			new ColumnData(t.Name, "title"),
			new ColumnData(t.Description, "description"),
		];

		return (
			<div style={{padding: '10px'}}>
				<div style={{marginBottom: '10px'}}><Button onClick={this.onNewClick} color="primary" style={{}}><AddIcon />{t.CreateNewCateogry}</Button></div>
				<CategoryList
					columns={columns}
					items={categories}
					title={t.Categories}
					onOpenClick={(category: Category) => this.onOpenClick(category)}
					onCopyClick={(category: Category) => this.onCopyClick(category)}
					onDeleteClick={(category: Category) => this.onDeleteClick(category)}
					onActionDeleteClick={(categories: Category[]) => this.onActionDeleteClick(categories)}
					tab={this.props.tab}
				/>
			</div>
		);
	}

	onNewClick() {
		TabsService.createTab(t.NewCategory, TabTypes.CATEGORIES_NEW, new Category())
	}
}

export default connect(mapStateToProps)(CategoriesTab);
